import { render, staticRenderFns } from "./KeywordsHeaderRenderer.vue?vue&type=template&id=87445f0c"
import script from "./KeywordsHeaderRenderer.vue?vue&type=script&lang=js"
export * from "./KeywordsHeaderRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports